// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2f6TM","col":"styles_col__64B-v","fulfillmentStatus":"styles_fulfillmentStatus__1b34Y","emailCol":"styles_emailCol__M6Gvf"};